import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NotaFiscalServicoModel as NotaFiscalServico } from '../models/notaFiscalServico.model';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { NotaFiscalConsultaModel } from '../models/nfseConsulta.model';

@Injectable({
  providedIn: 'root',
})
export class NotaFiscalService {
  private apiUrl = `${environment.advContabilApi}/api/nfse`;

  constructor(private http: HttpClient) { }

  listaNotasFiscaisServico(usuarioId: string): Observable<NotaFiscalServico[]> {
    const params = new HttpParams().set('usuarioId', usuarioId);
    return this.http.get<NotaFiscalServico[]>(`${this.apiUrl}/listar`, { params });
  }

  cancelaNotaFiscalServico(
    justificativaCancelamento: string,
    refId: string,
    cnpj: string
  ): Observable<NotaFiscalServico> {
    const params = new HttpParams()
      .set('justificativa', justificativaCancelamento)
      .set('cnpj', cnpj);

    return this.http.delete<NotaFiscalServico>(
      `${this.apiUrl}/CancelarNfse/${refId}`,
      { params }
    );
  }

  criarNfse(nfseData: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/CriarNfseProd`, nfseData);
  }

  preVisualizarNfse(nfseData: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/CriarNfse`, nfseData);
  }

  consultarNfse(refId: string, cnpj: string): Observable<NotaFiscalConsultaModel> {
    const params = new HttpParams()
      .set('refId', refId)
      .set('cnpj', cnpj);

    return this.http.get<NotaFiscalConsultaModel>(
      `${this.apiUrl}/ConsultarNfse`,
      { params }
    );
  }

  baixarPlanilhaModelo(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/DownloadPlanilhaModelo`, {
      responseType: 'blob',
    });
  }

  uploadPlanilha(arquivo: File, usuarioId: string): Observable<any> {
    const formData = new FormData();
    formData.append('arquivo', arquivo);
    formData.append('usuarioId', usuarioId);

    return this.http.post(`${this.apiUrl}/ProcessarPlanilha/ImportarPlanilha`, formData);
  }

  lerPlanilha(arquivo: File): Observable<any[]> {
    const formData = new FormData();
    formData.append('arquivo', arquivo);

    return this.http.post<any[]>(`${this.apiUrl}/LerPlanilha`, formData);
  }

  processarPlanilha(nfseDtos: any[], usuarioId: string): Observable<any> {
    const params = new HttpParams().set('usuarioId', usuarioId);
    return this.http.post(`${this.apiUrl}/ProcessarPlanilha`, nfseDtos, { params });
  }

  listarCodigosEmitidos(usuarioId: string): Observable<string[]> {
  return this.http.get<string[]>(`${this.apiUrl}/ListarCodigosEmitidos?usuarioId=${usuarioId}`);
  }

  abrirPdfNfse(url: string, refId: string, cnpj: string): Observable<boolean> {
    if (url) {
      window.open(url, '_blank');
      return of(true);
    } else {
      return this.consultarNfse(refId, cnpj).pipe(
        map(response => {
          if (response.url) {
            window.open(response.url, '_blank');
            return true;
          }
          return false;
        })
      );
    }
  }

  abrirXmlNfse(caminhoXml: string, refId: string, cnpj: string): Observable<boolean> {
    if (caminhoXml) {
      const base = 'https://api.focusnfe.com.br';
      const path = caminhoXml.startsWith('/') ? caminhoXml : `/${caminhoXml}`;
      window.open(`${base}${path}`, '_blank');
      return of(true);
    } else {
      return this.consultarNfse(refId, cnpj).pipe(
        map(response => {
          if (response.caminho_xml_nota_fiscal) {
            const base = 'https://api.focusnfe.com.br';
            const path = response.caminho_xml_nota_fiscal.startsWith('/') ? response.caminho_xml_nota_fiscal : `/${response.caminho_xml_nota_fiscal}`;
            window.open(`${base}${path}`, '_blank');
            return true;
          }
          return false;
        })
      );
    }
  }

  consultarEAtualizarNfse(refId: string, cnpj: string): Observable<NotaFiscalConsultaModel> {
    return this.consultarNfse(refId, cnpj);
  }
}
